<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>
        <div class="flex">
          <!-- <div class="w-1/2 ml-5">
            <vs-select
              :label="$t('AccountTitle')"
              v-model="command.accountType"
              name="AccountTitle"
              class="w-full"
              v-validate="'required'"
              @change="findAccount(command.accountType)"
            >
              <vs-select-item
                v-for="item in accountTypes"
                class="w-full"
                :value="item.id"
                :text="item.name"
              />
            </vs-select>
          </div> -->
          <div class="w-1/2">
                <label class="vs-select--label">{{ $t("CostTitle") }}</label>
                <v-select
                  label="name"
                  :options="costTitle"
                  name="CostTitle"
                  v-model="command.account"
                  :clearable="false"
                  dir="rtl"
                >
                </v-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('CostTitle')"
                  >{{ errors.first("CostTitle") }}</span
                >
            <!-- <span>{{ $t("Account") }}</span>
            <v-select
              label="title"
              :options="costTitle"
              name="Account"
              v-model="command.account"
              :clearable="false"
              dir="rtl"
            > -->
              <!-- <vs-select-item
                v-for="acc in costTitle"
                class="w-full"
                :value="acc.id"
                :text="acc.name"
              >
              </vs-select-item> -->
            <!-- </v-select> -->
          </div>
          <vs-button
            class="btn-drop vs-component vs-button bg_l_green bg-danger mt-6 mr-5"
            color="success"
            icon="add"
            @click.prevent="AddAccounts(command)"
          ></vs-button>
        </div>
        <div>
          <table
            v-if="asignCostTitle && asignCostTitle.length > 0"
            class="basic-tbl mt-5"
            id="colored-table"
          >
            <thead>
              <tr>
                <th style="width: 10%">{{ $t("CostTitle") }}</th>
                <!-- <th style="width: 10%">{{ $t("Account") }}</th> -->
                <th style="width: 10%">{{ $t("Action") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="account in asignCostTitle">
                <!-- <td style="width: 10%">
                  <span v-if="account.accountType == 1">گروه حساب</span>
                  <span v-if="account.accountType == 2">حساب کل</span>
                  <span v-if="account.accountType == 3">حساب معین</span>
                  <span v-if="account.accountType == 4">حساب تفضیلی</span>
                  <span v-if="account.accountType == 5">حساب شناوری</span>
                </td> -->
                <td style="width: 10%">
                  <span >
                    {{ account.name ? account.name : "" }}
                  </span>
                </td>
                <td style="width: 10%">
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteAccount(i)"
                    class="d-inline remove-btn flex-shrink-0"
                  ></vs-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <vs-button
          type="filled"
          class="float-right mb-4 mt-12"
          @click.prevent="submitForm"
          :disabled="asignCostTitle && asignCostTitle.length == 0"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "@/components/CustomVSelect.vue";

const dict = {
  custom: {
    CostTitle: {
      required: "لطفا عنوان هزینه را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  components: {
    "v-select": vSelect,
  },
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    costTitle:{
      default:[],
      type:Array,
    },
    asignCostTitle:{
      default:[],
      type:Array,
    }
  },
  data() {
    return {
      accountTypes: [
        { id: 1, name: "گروه حساب" },
        { id: 2, name: "حساب کل" },
        { id: 3, name: "حساب معین" },
        { id: 4, name: "حساب تفضیلی" },
        { id: 5, name: "حساب شناوری" },
      ],
      allAccounts: [],
      accountsId: [],
      command: {},
      popupTitle: "",
      disabled: false,
      gridDataSource: {
        type: "app",
        // service: this.model.accountInfo,
      },
    };
  },

  computed: {
    showModal: {
      get: function () {
        // this.fetchCostTitleByParent(this.model.id);
        // this.fetchCostTitle();

        return this.show;
      },
      set: function () {
        this.command.account = null;
        this.command.accountType = null;
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createAccount: "pettyCash/createAccountParty",
      // fetchAllCostTitleByParent: "pettyCash/fetchAllCostTitleByParent",
      // fetchCostTitle: "pettyCash/fetchCostTitle",
    }),
    // fetchCostTitleByParent(id) {
    //   this.allAccounts = [];
    //   if (this.command.accountType) {
    //     this.fetchAllCostTitleByParent(id).then((result) => {
    //       result.forEach((element) => {
    //         var x = {
    //           name: `${element.name} (${element.id})`,
    //           id: element.id,
    //         };

    //         this.this.accountsId.push(x);
    //       });
    //     });
    //   }
    // },
    // fetchCostTitle() {
    //   this.allAccounts = [];
    //   if (this.command.accountType) {
    //     this.fetchAllCostTitleByParent(model).then((result) => {
    //       result.forEach((element) => {
    //         var x = {
    //           name: `${element.name} (${element.id})`,
    //           id: element.id,
    //         };

    //         this.allAccounts.push(x);
    //       });
    //     });
    //   }
    // },
    AddAccounts(model) {
      var duplicateCondition = this.asignCostTitle.findIndex(
        (x) =>
        x.id == model.account.id
      );
      if (duplicateCondition === -1) {
        this.asignCostTitle.push({
          id: model.account.id,
          name: model.account.name,
        });
      } else {
        this.$swal({
          position: "center-center",
          type: "warning",
          text: "حساب موردنظر تکراری است!",
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    deleteAccount(index) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.asignCostTitle.splice(index, 1);
        }
      });
    },
    submitForm() {
      if (this.model.id != null) {
        var payload = {
          id: this.model.id,
          costTitlesInfo: this.asignCostTitle,
        };
        this.createAccount(payload).then(() => {
          this.$swal({
            position: "center-center",
            type: "success",
            text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
            showConfirmButton: false,
            timer: 2000,
          });
          this.$emit("finish");
          this.model = {};
          this.command.account = null;
          this.asignCostTitle = [];
          this.$validator.reset();
          this.disabled = false;
        });
      }
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.disabled = false;
        this.popupTitle = "AccountCreate";
      }
      this.$validator.reset();
    },
  },
};
</script>
